import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { NgIf } from '@angular/common';
import { DxSelectBoxModule } from 'devextreme-angular';

import { BodyType, RequestItem } from '../../../../state/integration-tester.models';
import { ItBodyEditorComponent } from './body-editor/it-body-editor.component';
import { PrettyJsonPipe } from 'libs/application-link/feature/src/lib/pipes/pretty_json.pipe';
import { PrettyXmlPipe } from 'libs/application-link/feature/src/lib/pipes/pretty_xml.pipe';
import { TrustHtmlPipe } from 'libs/application-link/feature/src/lib/pipes/trust_html.pipe';
import { isJsonLike, isXmlLike } from '../../../../state/integration-tester.util';

@Component({
  selector: 'it-body-tab',
  standalone: true,
  templateUrl: './it-body-tab.component.html',
  styleUrls: ['./it-body-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    DxSelectBoxModule,
    PrettyJsonPipe,
    PrettyXmlPipe,
    TrustHtmlPipe,
    ItBodyEditorComponent,
  ],
})
export class ItBodyTabComponent {
  @Input({ required: true }) request!: RequestItem;

  @Output() updateRequest = new EventEmitter<Partial<RequestItem>>();
  @Output() formatBody = new EventEmitter<void>();
  @Output() clearBody = new EventEmitter<void>();

  isBodyEditing = false;

  readonly bodyTypes: Array<{ label: string; value: BodyType }> = [
    { label: 'None', value: 'none' },
    { label: 'JSON', value: 'json' },
    { label: 'XML', value: 'xml' },
    { label: 'Text', value: 'text' },
  ];

  toggleBodyEdit(): void { this.isBodyEditing = !this.isBodyEditing; }
  lockBody(): void { this.isBodyEditing = false; }

  isJsonLike(text: string) { return isJsonLike(text); }
  isXmlLike(text: string) { return isXmlLike(text); }
}
